import { render } from "./PageContent-page.vue?vue&type=template&id=4f113b45&scoped=true"
import script from "./PageContent-page.vue?vue&type=script&lang=js"
export * from "./PageContent-page.vue?vue&type=script&lang=js"

import "./PageContent-page.vue?vue&type=style&index=0&id=4f113b45&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f113b45"]])

export default __exports__